import {
  MdAccountCircle,
  MdKeyboardBackspace,
  MdLogout,
  MdSettings,
} from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { IoIosSearch } from "react-icons/io";
import { useSearch } from "../../context/SearchContext";
import Notification from "../Comman/Notification";
import { BellIcon } from "lucide-react";
import LogoutModal from "../../Modal/LogoutModal";
import { useNotifyCount } from "../../store/Notifycount";
import { toast } from "react-toastify";
import { WebService } from "../../services/WebService";
import { useSelector } from "react-redux";
import useModalCloseHook from "../../hooks/useModalCloseHook";
import MyProfileModal from "../../Modal/MyProfileModal";
import { ADMIN } from "../../constants/roles";
import { MdOutlineChat } from "react-icons/md";
import { useChatNotifyCount } from "../../store/ChatNotifyCount";
import ChatNotification from "./ChatNotification";
import { ProfileImage } from "../../Assets/common";

export default function PageHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("location",location);
  
  const header = sessionStorage.getItem("header");

  const modalRef = useRef(null);
  const searchModalRef = useRef(null);

  const { setNotifyCount, notifyCount } = useNotifyCount();
  const { setChatNotifyCount, chatNotifyCount } = useChatNotifyCount();
  const user = useSelector((state) => state?.auth?.user);
  const isAdmin = user?.role === ADMIN;
  const { searchTerm, setSearchTerm } = useSearch();

  const [isNotification, setIsNotification] = useState(false);
  const [isChatNotification, setIsChatNotification] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);

  useModalCloseHook(modalRef, () => setIsOpen(false));
  useModalCloseHook(searchModalRef, () => setShowMobileSearch(false));

  const handleTab = (tab) => {
    setIsOpen(false);
    if (tab === "profile") setShowProfileModal(true);
    else if (tab === "setting") {
      sessionStorage.setItem("header", "Setting");
      navigate("/setting");
    } else setIsLogout(true);
  };

  useEffect(() => setSearchTerm(""), [location.pathname]);

  useEffect(() => {
    const fetchNotifyCount = async () => {
      try {
        const response = await WebService.getNotifyCount();
        if (response) {
          setNotifyCount(response.documentCnt);
          setChatNotifyCount(response.messageCnt);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };
    fetchNotifyCount();
  }, []);

  const handleBack = () => {
    if (location.pathname.includes("dashboard")) {
      return; 
    }

    navigate(-1);
  };

  return (
    <>
      {isNotification && <Notification setIsNotification={setIsNotification} />}
      {isChatNotification && (
        <ChatNotification setIsNotification={setIsChatNotification} />
      )}
      {isLogout && <LogoutModal setIsLogout={setIsLogout} />}
      {showProfileModal && (
        <MyProfileModal
          isOpen={showProfileModal}
          onClose={() => setShowProfileModal(false)}
        />
      )}

      <section className="px-4 py-4 shadow-sm border-b border-zinc-300 text-primary relative">
        <div className="flex items-center justify-between gap-2">
          {/* Back Button */}
          <button
            onClick={handleBack}
            className="flex items-center gap-2 text-sm md:text-base xl:text-xl font-semibold"
          >
            <MdKeyboardBackspace className="ml-10 lg:ml-0 text-xl md:text-2xl" />

            <span className="">
              {header || "-"}
            </span>
          </button>
      

          {/* Right Icons */}
          <div className="flex items-center gap-3">
            {/* Desktop Search */}
            <div className="relative hidden md:flex w-[220px]">
              <input
                type="search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search here..."
                className="p-2 w-full border border-zinc-400 pl-7 rounded"
              />
              <IoIosSearch className="absolute top-3 left-2 text-gray-400" />
            </div>

            {/* Mobile Search Icon */}
            <button
              onClick={() => setShowMobileSearch(true)}
              className="md:hidden p-2"
            >
              <IoIosSearch className="h-6 w-6 text-gray-700" />
            </button>

            {/* Notification */}
            <button
              onClick={() => setIsNotification(true)}
              className="relative p-2"
            >
              <BellIcon className="h-6 w-6" />
              {notifyCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 text-xs bg-red-500 text-white rounded-full flex items-center justify-center">
                  {notifyCount}
                </span>
              )}
            </button>

            {/* Chat */}
            <button
              onClick={() => setIsChatNotification(true)}
              className="relative p-2"
            >
              <MdOutlineChat className="h-6 w-6" />
              {chatNotifyCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 text-xs bg-red-500 text-white rounded-full flex items-center justify-center">
                  {chatNotifyCount}
                </span>
              )}
            </button>

            {/* Profile */}
            <div className="relative">
              <img
                onClick={() => setIsOpen((p) => !p)}
                src={user?.profile || ProfileImage }
                alt="Profile"
                className="h-8 w-8 rounded-full border cursor-pointer"
              />
              

              {isOpen && (
                <div
                  ref={modalRef}
                  className="absolute right-0 top-10 w-40 bg-white border shadow-md rounded z-50"
                >
                  <button
                    onClick={() => handleTab("profile")}
                    className="w-full px-4 py-2 hover:bg-gray-100 flex gap-2 items-center"
                  >
                    <MdAccountCircle /> Profile
                  </button>

                  {isAdmin && (
                    <button
                      onClick={() => handleTab("setting")}
                      className="w-full px-4 py-2 hover:bg-gray-100 flex gap-2 items-center"
                    >
                      <MdSettings /> Settings
                    </button>
                  )}

                  <button
                    onClick={() => handleTab("logout")}
                    className="w-full px-4 py-2 hover:bg-gray-100 flex gap-2 items-center"
                  >
                    <MdLogout className="text-red-500" /> Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Search Modal */}
        {showMobileSearch && (
          <div
            ref={searchModalRef}
            className="absolute top-full left-0 w-full bg-white border-b shadow-md p-3 md:hidden z-40"
          >
            <div className="relative">
              <input
                autoFocus
                type="search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search here..."
                className="w-full p-2 border border-zinc-400 pl-8 rounded"
              />
              <IoIosSearch className="absolute top-3 left-2 text-gray-400" />
            </div>
          </div>
        )}
      </section>
    </>
  );
}
